import { Injectable } from '@angular/core';
import { Observable ,  from as fromPromise } from 'rxjs';
import { AppService } from './../../app.service';
import { VwdOption } from '@vwd/vwd-pilldown';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class SettingsBoxService {

  private financeApi: any;

  constructor(
    private api: AppService,
    private translate: TranslateService
  ) {
    this.financeApi = api.getInstance();
    console.log('Api in Settings', this.financeApi);
   }


  getFrequenciesOptOptions(): Observable<VwdOption[]> {
    return fromPromise(this._getFrequenciesOptions());
  }

  private _getFrequenciesOptions(): Promise<VwdOption[]> {

    const optArray: VwdOption[] = [];

    console.log('_getFrequenciesOptions', this.financeApi);

    return this.financeApi.find({
      service: 'bond.getBondCouponFrequencies',
      source: 'SW',
      param: {}
    }).then((result: any) => {

      if (result.length === 0) {
        const myError: any = new Error('Frequencies not found');
        myError.code = 'FREQUENCIES_NOT_FOUND';
        throw myError;
      }

      result.data.forEach((item) => {
        // tslint:disable-next-line:max-line-length
        optArray.push(new VwdOption(this.translate.instant(`WIDGETS.BOND_CALCULATOR.CONTENT.SETTINGS_BOX.TABLE.COUPON_FREQUENCIES.${item.key}`), item.key));
      });
      return optArray;
    });

  }

  getBondCalculationMethodeOptions(): Observable<VwdOption[]> {
    return fromPromise(this._getBondCalculationMethodeOptions());
  }

  private _getBondCalculationMethodeOptions(): Promise<VwdOption[]> {

    const optArray: VwdOption[] = [];

    return this.financeApi.find({
      service: 'bond.getBondCalculationMethods',
      source: 'SW',
      param: {}
    }).then((result: any) => {

      if (result.length === 0) {
        const myError: any = new Error('Calculation methodes not found');
        myError.code = 'CALCULATION_METHODES_NOT_FOUND';
        throw myError;
      }

      result.data.forEach((item) => {
        optArray.push(new VwdOption(item.description, item.key));
      });
      return optArray;
    });

  }


  getBondDayCountConventionOptions(): Observable<VwdOption[]> {
    return fromPromise(this._getBondDayCountConventionOptions());
  }

  private _getBondDayCountConventionOptions(): Promise<VwdOption[]> {

    const optArray: VwdOption[] = [];

    return this.financeApi.find({
      service: 'bond.getBondDayCountConventions',
      source: 'SW',
      param: {}
    }).then((result: any) => {

      if (result.length === 0) {
        const myError: any = new Error('Day conventions not found');
        myError.code = 'DAY_CONVENTIONS_NOT_FOUND';
        throw myError;
      }

      result.data.forEach((item) => {
        optArray.push(new VwdOption(item.description, item.key));
      });
      return optArray;
    });
  }
}

